import React from 'react';
import { Modal } from 'react-bootstrap';
import ExportAbstentions from '../ExportAbstentions';
import WhatsappList from '../WhatsappList';

export default function AbstentionsModal(props) {
  const {
    show,
    setShow,
    getAbstentions,
    institution = '',
    monthFilter,
    areasList = []
  } = props;
  return (
    <>
      <Modal size="lg" show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Pulsos não medidos</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ExportAbstentions
            monthFilter={monthFilter}
            areasFilter={areasList}
          />

          <WhatsappList
            getAbstentions={getAbstentions}
            institution={institution}
            monthFilter={monthFilter}
            areasList={areasList}
          />
        </Modal.Body>
      </Modal>
    </>
  );
}
